<div class="p-3">
   <div class="flex">
      <h2 class="flex-auto">{{title}}</h2>
      <div class="justify-items-end">
         <button [mat-dialog-close]="null" class="flex-auto"> <mat-icon>close</mat-icon></button>
      </div>
   </div>
   <div class="pb-5">
      <div [innerHTML]="msg"></div>
   </div>
</div>

<div class="grid grid-cols-2 h-[82px]">
   <button [mat-dialog-close]="null" class="btn-modal-cancel">
      <span class="label-btn-modal">{{btn_cancel}}</span>
   </button>
   <button [mat-dialog-close]="true" cdkFocusInitial class="btn-modal-confirm">
      <span class="label-btn-modal">{{btn_confirm}}</span>
   </button>
</div>
